module.exports = __webpack_public_path__ + "img/piutang.672a72e5.svg";